import { type CancellablePromise, post } from "@/api";
import type { UpsellAccessRequest } from "@/validation";

export function submit(form: UpsellAccessRequest): CancellablePromise<void> {
  return post(`/v1/subscriptions/upsell-request`, form);
}
